import Carousel from './carousel';

class HeroProductCarousel extends Carousel {
  constructor(selector: any = '.js-hero-product-carousel', settings: object = {}) {
    const TIME = 8000;
    const SPEED = 800;

    const el: HTMLElement | null = document.querySelector(selector);
    const pagination: HTMLElement | null | undefined = el?.parentElement?.querySelector('.o-js-hero-product-carousel__pagination');

    super(el, {
      ...settings,
      effect: 'slide',
      speed: SPEED,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      // autoplay: {
      //   delay: TIME,
      //   disableOnInteraction: false,
      // },
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: (swiper: any) => {
          // pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);

          if (swiper.slides.length - 2 <= 1) {
            swiper.autoplay.stop();
            swiper.unsetGrabCursor();
            swiper.params.grabCursor = false;
            //swiper.params.loop = false;
            el?.classList.add('swiper-no-swiping');
          }

          el?.classList.remove('hidden');
        },
      },
    });
  }
}

export default HeroProductCarousel;
